module.exports = __webpack_public_path__ + "static/media/image-2.dd51ebe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/SEOin2020/image-2.png
// module id = 464
// module chunks = 0